import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  CONCEPT_DOMAIN, CONCEPT_NOTE_AUTOMATIC_THOUGHT_DETAIL_ENDPOINT,
  CONCEPT_NOTE_AUTOMATIC_THOUGHT_LIST_ENDPOINT,
  conceptApi,
} from 'api/conceptApi'

import CustomModal from "components/common/CustomModal";
import Link from "components/common/Link";
import { useCallback, useState } from "react";
import { useRecoilValue } from "recoil";
import { patientAtom } from "recoil/patientAtom";

export default function DeleteAutomaticThoughtButton({
  automaticThoughtId,
  thoughtRecordKey,
  isForValue = false,
}: {
  automaticThoughtId: string;
  thoughtRecordKey?: string,
  isForValue?: boolean
}) {
  const queryClient = useQueryClient();
  const patientState = useRecoilValue(patientAtom);

  const deleteAutomaticThoughtQueryFn = useCallback(
    () =>
      conceptApi.deleteAutomaticThought(
        patientState?.patientId!!,
        `${automaticThoughtId}`,
        isForValue
      ),
    [patientState?.patientId, automaticThoughtId, isForValue]
  );

  const { mutate: deleteAutomaticThought } = useMutation(
    deleteAutomaticThoughtQueryFn,
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          CONCEPT_DOMAIN,
          CONCEPT_NOTE_AUTOMATIC_THOUGHT_LIST_ENDPOINT,
          patientState?.patientId,
        ]);

        if (thoughtRecordKey) {
          queryClient.invalidateQueries([
            CONCEPT_DOMAIN,
            CONCEPT_NOTE_AUTOMATIC_THOUGHT_DETAIL_ENDPOINT,
            patientState?.patientId,
            thoughtRecordKey,
          ]);
        }
      },
    }
  );

  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
      >
        <Link text="삭제" opacity={1} textColor="primary.solid" />
      </div>
      <CustomModal
        open={open}
        onClose={() => setOpen(false)}
        title={"이 자동적 사고를 삭제할까요?"}
        subtitle={""}
        actions={[
          {
            label: "삭제하기",
            variant: "Solid",
            color: "danger",
            onClick: () => {
              deleteAutomaticThought();
              setOpen(false);
            },
          },
        ]}
      />
    </>
  );
}